// components/SQLResultMessage.tsx
import React, { Suspense, useState } from 'react';
import TableComponent from '../TableComponent';
import ChartComponent from '../ChartComponent';
import SQLStatement from '../SQLStatement';
import {
  IconFileCode,
  IconPerformanceIncreaseAlt,
  IconLayoutModule,
} from '@cimpress-technology/react-streamline-icons/lib';

const SQLResultMessage: React.FC<{
  message: any;
  executeSQLStatement: () => void;
}> = ({ message, executeSQLStatement }) => {
  const [activeTab, setActiveTab] = useState<'sql' | 'chart' | 'query'>('sql');
  const [SQLExecuted] = useState(false);

  const handleTabChange = (tab: 'sql' | 'chart' | 'query') => {
    setActiveTab(tab);
  };

  return (
    <div className="chat-message-container">
      <div className="sql_result_heading">SQL Results and Visualization</div>
      <div className="tabs">
        <button
          className={`tab ${activeTab === 'sql' ? 'active' : ''}`}
          onClick={() => handleTabChange('sql')}
        >
          <IconLayoutModule
            style={{ color: '#2DCCD3', height: '40px' }}
            className="tab-icon"
            weight="fill"
          />
          <span className="tab-text">SQL Result</span>
        </button>

        <button
          className={`tab ${activeTab === 'chart' ? 'active' : ''}`}
          onClick={() => handleTabChange('chart')}
        >
          <IconPerformanceIncreaseAlt
            style={{ color: '#4F8A8B', height: '40px' }}
            className="tab-icon"
            weight="fill"
          />
          <span className="tab-text">Data Visualization</span>
        </button>

        <button
          className={`tab ${activeTab === 'query' ? 'active' : ''}`}
          onClick={() => handleTabChange('query')}
        >
          <IconFileCode
            style={{ color: '#E17055', height: '40px' }}
            className="tab-icon"
            weight="fill"
          />
          <span className="tab-text">SQL Query</span>
        </button>
      </div>
      <div className="tab-content">
        {activeTab === 'sql' && (
          <div className="sql-message">
            {!message.data ||
              message.data === undefined ||
              (Array.isArray(message.data) && message.data.length === 0) ? (
              <p className="sql_result_no_data">
                No results found. Please check the SQL in the{' '}
                <strong>SQL Query Tab</strong>.
              </p>
            ) : (
              <TableComponent
                columns={message.columns}
                data={message.data}
                columnMetadata={message.columnMetadata}
              />
            )}
          </div>
        )}
        {activeTab === 'chart' && (
          <div className="chart-message">
            {!message.data ||
              !Array.isArray(message.data) ||
              message.data.length === 0 ? (
              <p className="sql_result_no_data">
                No results found. Click on SQL Query Tab to view the query.
              </p>
            ) : (
              <Suspense
                fallback={
                  <div className="sql_result_loading">Loading Chart...</div>
                }
              >
                <ChartComponent
                  data={message.data}
                  chartType="bar"
                  metadata={{ width: 900, height: 400 }}
                />
              </Suspense>
            )}
          </div>
        )}
        {activeTab === 'query' && (
          <div className="sql-query-message">
            <SQLStatement
              statement={message.sql}
              executeSQLStatement={executeSQLStatement}
              SQLExecuted={SQLExecuted}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SQLResultMessage;
